// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__2dLn-","checkbox":"Checkbox_checkbox__1D-LR","checkmark":"Checkbox_checkmark__3HE8f","checked":"Checkbox_checked__3XKWm"};